import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Card from '@mui/material/Card';
import { CardContent, Typography, Button } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { formatDistanceToNow } from 'date-fns';
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom"
import { Link } from 'react-router-dom';
import QuoteOfTheDay from './QuoteOfTheDay';
import MainData from './mainData';


const useStyles = makeStyles(() => ({
  containerCover: {
    display: 'flex',
    justifyContent: 'center'
  },
  tendingStyle: {
    display:'flex',
    justifyContent:'start',
    width: (props) => `${props.trendingWidth}%`,
 
  }
}));

const TitleTypography = styled(Typography)`
  font: 700 14px/1.71 Merriweather; 
  color: #333;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #39927C; /* Change color on hover as needed */
  }

  a {
    color: black; /* Set the desired link text color */
  }
`;
const SlideContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
`;


const NavigationButtons = styled.div`
  flex: 1;
  text-align: center;
`;

const StyledNavigateBeforeIcon = styled(NavigateBeforeIcon)`
  color: ${(props) => (props.disabled ? '#ccc' : '#000')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  border-radius: 50%;
  radius: 30%
  padding: 8px;
  style: ${(props) => (props.disabled ? { fontSize: '24px' } : { fontSize: '24px' })}; /* Adjust the font size as needed */


  &:hover {
    background-color: ${(props) => (props.disabled ? 'transparent' : '#39927C')};
  }
`;


const StyledNavigateNextIcon = styled(NavigateNextIcon)`
  color: ${(props) => (props.disabled ? '#ccc' : '#000')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  border-radius: 50%;
  radius: 30%
  padding: 8px;
  style: ${(props) => (props.disabled ? { fontSize: '24px' } : { fontSize: '24px' })}; /* Adjust the font size as needed */
  
  &:hover {
    background-color: ${(props) => (props.disabled ? 'transparent' : '#39927C')};
  }
`;


const ContentContainer = styled.div`
  flex: 2;
  display: flex;
  flex-wrap:wrap;
  gap: 6px;
  position: relative; /* Set the container as relative for absolute positioning inside */
  margin-top: 50px;
`;

const ContentCard = styled(Card)`
margin-bottom: 20px;

`;

const Separator = styled.div`
  width: 0.2px; /* Adjust spacing as needed */
`;
const DateCaption = styled(Typography)`
  font-size: 12px;
  line-height: 1.17;
  font-family: 'Work Sans', sans-serif; /* Replace 'Work Sans' with your preferred font family */
  color: #737373;
`;

const TrendingButton = styled(Button)`
  margin-bottom: 1px;
  margin-top: 3px;
  background: linear-gradient(45deg, #ff3232, #bd8c05); /* Adjust colors as needed */
  color: #fff; /* Set text color to white or another suitable color */
`;
const TrendingContainer = styled.div`
  position: absolute;
  top: -44px;
  
  text-align: center;
  /* margin: 5px; // Adjust the margin as needed */
`;

const HomeContainer = styled.div`
  position: relative; /* Set the container as relative for absolute positioning inside */
  display: 'flex';
  flexDirection:'coloumn',
  align-items: center;
  justify-content: space-between;

`;

const OuterContainer = styled.div`
  border: 2px solid #FFD700; /* Yellow border color */
  padding: 20px; /* Adjust padding as needed */
  text-align: center;
`;


const Home = () => {
  
  const [currentPage, setCurrentPage] = useState(1);
  var [cardWidth,setCardWidth] = useState(window.innerWidth > 600 ? 25 : 100);
  var [trendingWidth,setTrendingWidth] = useState(window.innerWidth > 600 ? 78 : 100);
  const itemsPerPage = window.innerWidth > 600 ? 6 : 1; // For example, show 6 cards on wider screens and 1 card on smaller screens
  const search = useLocation().search
  const searchKey = new URLSearchParams(search).get('search')
  const [stories, setStories] = useState([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const [category, setCategory] = useState(''); // For example, 'Business and Finance'
  const [categories, setCategories] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);



  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    const maxPages = Math.ceil(stories.length / itemsPerPage);
    setCurrentPage((prevPage) => Math.min(prevPage + 1, maxPages));
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentContent = stories.slice(startIndex, endIndex);

  useEffect((e) => {
    const getStories = async () => {
      
     window.addEventListener('resize',()=>{
      var width=window.innerWidth;
      var height=window.innerHeight;
      setCardWidth(window.innerWidth > 600 ? 25 : 100)
      setTrendingWidth(window.innerWidth > 600 ? 78 : 100);

      
     })
      setLoading(true)
      try {
         
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/story/getAllStories?search=${searchKey || ""}&page=${page}`)

       
        if (searchKey) {
          navigate({
            pathname: '/',
            search: `?search=${searchKey}${page > 1 ? `&page=${page}` : ""}`,
          });
        }
        else {
          navigate({
            pathname: '/',
            search: `${page > 1 ? `page=${page}` : ""}`,
          });


        }
        setStories(data.data)
        setPages(data.pages)

        setLoading(false)
      }
      catch (error) {
        setLoading(true)
      }
    }
    getStories()
  }, [setLoading, search, page, navigate])


  const styles=useStyles({trendingWidth});
  return (
    <div>
    <HomeContainer>

      <SlideContainer>

        <NavigationButtons>
          <StyledNavigateBeforeIcon onClick={handlePreviousPage} disabled={currentPage === 1} />

        </NavigationButtons>

        <ContentContainer className={styles.containerCover}>
          <TrendingContainer className={styles.tendingStyle}>
            <TrendingButton size="small">
              Trending
            </TrendingButton>
          </TrendingContainer>
          {
            itemsPerPage===3?`<br>`:''
          }
          {currentContent.map((story, index) => (
            <React.Fragment key={story._id} >
              <ContentCard sx={{width:`${cardWidth}%`}}>
                <CardContent>
                  <DateCaption variant="caption" color="textSecondary">
                    {formatDistanceToNow(new Date(story.updatedAt), { addSuffix: false })} ago
                  </DateCaption>
                  <TitleTypography variant="h6">
                    <Link to={`/story/${story.slug}`}>
                      {story.title.length > 60 ? `${story.title.slice(0, 57)}...` : story.title}
                    </Link>
                  </TitleTypography>                </CardContent>
              </ContentCard>
              {index < itemsPerPage - 1 && <Separator />}
            </React.Fragment>
          ))}
        </ContentContainer>

        <NavigationButtons>
          <StyledNavigateNextIcon onClick={handleNextPage} disabled={currentPage === Math.ceil(stories.length / itemsPerPage)} />

        </NavigationButtons>
      </SlideContainer>
      
     
    </HomeContainer>
    <div>
    <MainData/>
      <QuoteOfTheDay />
    

      
    </div>
    </div>
  );
};

export default Home;